import { all } from 'redux-saga/effects';
import appSagas from './app';
import modules from './modules';
import authSagas from './auth';
import homeSagas from './home';
import searchSagas from './search';
import userSagas from './user';
import notificationSagas from './notification';
import bookmarks from './bookmarks';
import events from './events';
import coursedetails from './coursedetails';
import courselist from './courselist';
import dashboard from './dashboard';
import publicSagas from './public';
import news from './news';
import newsletter from './newsletter';
import documents from './documents';
import documentsExpert from './documentsExpert';
import scorm from './scorm';
import statistics from './statistics';
import tutorCourseList from './tutorCourseList';
import tutors from './tutors';
import utils from './utils';
import liveEvent from './liveEvent';
import eventApproval from './eventApproval';
import supervisorStats from './supervisorStats';

export default function* rootSaga() {
  yield all([
    ...appSagas,
    ...modules,
    ...authSagas,
    ...bookmarks,
    ...coursedetails,
    ...courselist,
    ...dashboard,
    ...documents,
    ...documentsExpert,
    ...eventApproval,
    ...events,
    ...homeSagas,
    ...liveEvent,
    ...news,
    ...newsletter,
    ...notificationSagas,
    ...publicSagas,
    ...searchSagas,
    ...scorm,
    ...statistics,
    ...tutorCourseList,
    ...tutors,
    ...userSagas,
    ...utils,
    ...supervisorStats,
  ]);
}
